(ns frontend.view.error-utils
  (:require [frontend.logging :as logging]
            [frontend.view.modals.events :as modals]
            [frontend.view.modals.error-message.view :as error-message]))

(def last-error-atom (atom {}))

(defn log-error! [err]
  (reset! last-error-atom err)
  (logging/error "ERROR " (pr-str err)))

(defn show-error! [tr err]
  (reset! last-error-atom err)
  (logging/error "ERROR " (pr-str err))
  (let [message (:message err)]
    (modals/open-modal!
     error-message/modal-key
     {:body-content   [:<>
                       [:span (or message (tr :something-went-wrong))
                        [:i.fal.fa-exclamation-triangle]]
                       [:br]
                       [:span (tr :try-again-or-contact-support)]
                       [:a {:href (str "mailto:" (tr :support-email-address))}
                        (tr :support-email-address)]]
      :title          (tr :attention)
      :ok-button-text (tr :close)})))
